export default __webpack_public_path__ + "static/media/profile_place_holder.a2e6cda0.svg";